import React from 'react';
import './loading.css';

/** Single shimmer bone used by all skeleton layouts. */
const SkeletonBone = ({ className = '', style, circle = false, pill = false }) => {
  const classes = [
    'skeleton-bone',
    circle ? 'skeleton-bone--circle' : '',
    pill ? 'skeleton-bone--pill' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return <span className={classes} style={style} aria-hidden="true" />;
};

export default SkeletonBone;
